import { emitMessage } from './ws-actions';

export const SOCKET_SEARCH_MESSAGE = 'search';
export const SOCKET_SEARCH_RESULTS_MESSAGE = 'search results';
export const FETCH_SEARCH_RESULTS = 'search/FETCH_RESULTS';

export default function fetchSearchResults(uuid, results) {
  return {
    type: FETCH_SEARCH_RESULTS,
    payload: {
      uuid,
      results,
    },
  };
}

export function emitSearch(query, uuid) {
  return emitMessage(SOCKET_SEARCH_MESSAGE, '', { query, uuid });
}



// WEBPACK FOOTER //
// ./app/actions/search-socket.js